import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, Fragment } from 'react';
import { Modal, useModal } from '../modal';
import { SelectTrigger } from './trigger';
import { SelectMobileView } from './mobile-view';
import { useSelect } from './use-select';
export function MobileSelect({ placeholder, value, options, icon: Icon, onChange, clearable = false, emptyState, search, async, multiple, error = false, disabled = false, }) {
    const selectId = useId();
    const parentModal = useModal(true);
    const { isOpen, setOpen, handleClear, handleSelect, isSelected } = useSelect({
        value,
        onChange,
        multiple,
    });
    const mobileView = (_jsx(SelectMobileView, { title: placeholder, onBack: parentModal ? () => setOpen(false) : undefined, options: options, emptyState: emptyState, search: search, async: async, isSelected: isSelected, onSelect: handleSelect }));
    useEffect(() => {
        if (!parentModal || !isOpen) {
            return;
        }
        parentModal.push({
            id: selectId,
            component: mobileView,
        });
        // Stacked view is a frozen element — re-push when selection/options change so checkmarks stay in sync.
        // parentModal identity changes on every stack update — omit it from deps.
    }, [isOpen, selectId, value, options, emptyState, search, async]);
    useEffect(() => {
        if (!parentModal || !isOpen) {
            return;
        }
        return () => {
            parentModal.pop();
        };
    }, [isOpen, selectId]);
    return (_jsxs(Fragment, { children: [_jsx(SelectTrigger, { value: value, placeholder: placeholder, icon: Icon, clearable: clearable, error: error, disabled: disabled, onClear: handleClear, onClick: () => setOpen(true) }), isOpen && !parentModal && (_jsx(Modal, { onClose: () => setOpen(false), children: mobileView }))] }));
}
